



























































































































































import Vue from 'vue';
import massClient from '../../apis';
import News from '../../models/News';
import massVuex from '../../vuex/common';

export default Vue.extend({
  mixins: [massVuex],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    isMulti: {
      type: Boolean,
      default: true,
    },
    isMass: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showNewsBox: true,
      current: 1,
      total: 0,
      pageSize: 10,
      leftData: [],
      rightData: [],
      news: null,
      hoverIndex: null,
      keywordSearchSuccess: false,
      keyword: null,
      loading: false,
      loaded: false,
      localShow: false,
    };
  },
  filters: {
    toHttps(v: string | null): string {
      return (v || '').replace('http://', 'https://')
    },
  },
  methods: {

    changePage(page: number) {
      if (this.current !== page) {
        this.current = page;
        this.loadNews();
      }
    },
    loadNews() {
      massClient.getNews({
        page: this.current,
        size: this.pageSize,
        keyword: this.keyword,
        isMulti: this.isMulti,
        isMass: this.isMass,
      }).success((r) => {
        this.leftData = [];
        this.rightData = [];
        const data: never[] = r.data;
        for (const k of data.keys()) {
          if (k % 2 === 0) {
            this.leftData.push(data[k]);
          } else {
            this.rightData.push(data[k]);
          }
        }
        this.total = r.total;
        this.loaded = true;
      });
    },
    clearKeyword() {
      this.keyword = null;
      this.keywordSearchSuccess = false;
      this.loadNews();
    },
    kewwordSearch() {
      if (this.keyword === null || this.keyword === '') {
        this.$Message.error('请输入标题或作者');
      } else {
        this.loading = true;
        massClient.getNews({
          page: 1,
          size: 100,
          keyword: this.keyword,
          isMulti: this.isMulti,
          isMass: this.isMass,
        }).success((r) => {
          this.leftData = [];
          this.rightData = [];
          const data: never[] = r.data;
          for (const k of data.keys()) {
            if (k % 2 === 0) {
              this.leftData.push(data[k]);
            } else {
              this.rightData.push(data[k]);
            }
          }
          this.keywordSearchSuccess = true;
          this.total = r.total;
        }).error((e) => {
          this.$Message.error(e.toString());
        }).done(() => {
          this.loading = false;
        });
      }
    },
    close() {
      this.$emit('close');
    },
    selectNews(item: any) {
      if (this.news && this.news.parentNews.id === item.parentNews.id) {
        this.news = null;
      } else {
        this.news = item;
      }
    },
    confirmNews() {
      this.$emit('confirm', this.news);
    },
  },
  watch: {
  },
  mounted() {
    this.loadNews();
  },
});
